module.exports = __webpack_public_path__ + "static/media/chorus.cd10e597.svg";